
































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class PatientMergeConfirm extends BaseComponent {
  @Prop()
  patientResult: any;

  
}
